module.exports = __webpack_public_path__ + "static/java-3fd87c9188b92e5571cea22c08f06669.jpg";